

import React, { Component } from 'react';
import autobind from 'class-autobind';
import PropTypes from 'prop-types';

import InfoPanelFolderUI from './info_panel.folder_ui.jsx';

import { confirm } from 'zoomforth_tools/modern_helpers.js';


class InfoPanelFolder extends Component {

  constructor(props) {
    super(props);
    autobind(this);
  }

  handleDeleteClick() {
    confirm(
      'You must remove all of the media from a folder to delete it. Really delete this folder?'
    )
      .done(()=> {
        this.props.folder.destroy({ 
          // This call fails if the folder is full; so we must wait
          wait: true 
        });
      });
  }

  handleRenameSave(newName) {
    return this.props.folder.rename(newName);
  }

  render() {
    const {   
      folder,
      isInSearchMode,
      pathAsFolderData,
      onFolderNavigate,
      onMoveClick

    } = this.props;

    return (
      <InfoPanelFolderUI
        isDeletable={folder.isDeletable()}
        isMovable={folder.isMovable()}
        isRenamable={folder.isRenamable()}
        isSpecialFolder={folder.isSpecialFolder()}
        isInSearchMode={isInSearchMode}
        name={folder.getName()}
        pathAsFolderData={pathAsFolderData}
        onFolderNavigate={onFolderNavigate}
        onDeleteClick={this.handleDeleteClick}
        onMoveClick={onMoveClick}
        onRenameSave={this.handleRenameSave}
      />
    );
  }

}

InfoPanelFolder.propTypes = {
  folder: PropTypes.object.isRequired,
  isInSearchMode: PropTypes.bool.isRequired,  
  pathAsFolderData: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number
  })).isRequired,
  onMoveClick: PropTypes.func.isRequired
};

export default InfoPanelFolder;